import { Heart as Heart_kojaro } from './Heart.kojaro';
import { Heart as Heart_phosphor } from './Heart.phosphor';
import { Heart as Heart_zoomg } from './Heart.zoomg';
import { Heart as Heart_zoomit } from './Heart.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Heart_kojaro;

    case 'zoomg':
      return Heart_zoomg;

    case 'phosphor':
      return Heart_phosphor;

    default:
      return Heart_zoomit;
  }
};

export const Heart = IconRenderer();
